module.exports = __webpack_public_path__ + "img/Hilltop_Grill@2x.b9804a53.webp";